import helper, { bindUrl } from "../helper";

/**
 * 分页查询客户列表
 * @param params
 * @returns {*}
 */
export const pageQueryClient = function(params) {
  return helper.get("/client/pageQueryClient", params);
};

/**
 * 查询客户详情
 * @param params
 * @returns {*}
 */
export const queryClientInfo = function(params) {
  return helper.get("/client/queryClientInfo", params);
};
/**
 * 删除客户
 * @param params
 * @returns {*}
 */
export const removeClient = function(params) {
  return helper.delete("/client/removeClient", params);
};

/**
 * 查询客户公司接口
 * GET /client/queryClientCompany
 * @param {Object} queryParams
 * @param {number} queryParams.page - 当前页码,从1开始
 * @param {number} queryParams.limit - 每页记录数
 * @param {number} queryParams.userId - 用户id
 * @param {number} queryParams.id - 客户公司id
 * @param {number} queryParams.isNecessary -
 */
export function queryClientCompany(queryParams) {
  return helper.request({
    url: bindUrl("/client/queryClientCompany", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 删除客户公司
 * @param params
 * @returns {*}
 */

export const removeClientCompany = function(params) {
  return helper.delete("/client/removeClientCompany", params);
};

/**
 * 增加客户基础信息
 * @param params
 * @returns {*}
 */
export const addClient = function(params) {
  return helper.post("/client/addClient", params);
};
/**
 * 修改客户基础信息
 * @param params
 * @returns {*}
 */
export const updateClient = function(params) {
  return helper.post("/client/updateClient", params);
};
/**
 * 增加客户基础信息
 * @param params
 * @returns {*}
 */
export const addClientInfo = function(params) {
  return helper.post("/client/addClientInfo", params);
};
/**
 * 修改客户基础信息
 * @param params
 * @returns {*}
 */
export const updateClientInfo = function(params) {
  return helper.post("/client/updateClientInfo", params);
};
/**
 * 增加客户公司信息
 * @param params
 * @returns {*}
 */
export const addClientCompany = function(params) {
  return helper.post("/client/addClientCompany", params);
};
/**
 * 修改客户公司信息
 * @param params
 * @returns {*}
 */
export const updateClientCompany = function(params) {
  return helper.post("/client/updateClientCompany", params);
};

export const pageQueryCompany = function(params) {
  return helper.get("/client/pageQueryCompany", params);
};

export const queryCompanyList = function(params) {
  return helper.get("/client/queryCompanyList", params);
};

/**
 * 身份证正反面ocr认证
 */
export const ocrVerify = function(params) {
  return helper.request({
    url: bindUrl("/out/idImages", {}),
    method: "GET",
    params: params
  });
};
export const queryOwnClients = function(params) {
  return helper.get("/client/queryOwnClients", params);
};

export const queryOwnCompanys = function(params) {
  return helper.get("/client/queryOwnCompanys", params);
};

export const queryOwnWarehouse = function(params) {
  return helper.get("/warehouse/queryOwnWarehouse", params);
};

export const pageQueryOwnClients = function(params) {
  return helper.get("/client/pageQueryOwnClients", params);
};

export const pageQueryOwnCompanys = function(params) {
  return helper.get("/client/pageQueryOwnCompanys", params);
};

export const pageQueryWarehouseList = function(params) {
  return helper.get("/warehouse/pageQueryWarehouseList", params);
};

/**
 * 获取公司详情
 */
export const queryCompanyInfo = function(params) {
  return helper.get("/client/queryClientByCompanyId", params);
};

// 代收代付列表
export const queryAttachJournal = function(params) {
  return helper.get("/business/queryAttachJournal", params);
};

// 代收代付统计值
export const statistic = function(params) {
  return helper.get("/business/queryAttachJournal/statistic", params);
};

export const getWxJsSignature = function(params) {
  return helper.get("/v1/user/getWxJsSignature", params);
};

export const clientTowFactor = function(params) {
  return helper.post("/oil/app/client/towFactor", params);
};
